import React from 'react';
import { getImg } from '../../../Utils/getImg';
import * as Icons from '../Buttons/IconButton/Icons';
import { T } from '../Response/Utils';
import styled from 'styled-components';

const EachOption = styled.button`
  &:focus:not(.focus-visible) {
    background-color: ${(props: any) => {
      return props.foreground + '14';
    }};
  }
  &:hover {
    background-color: ${(props: any) => {
      return props.foreground + '14 !important';
    }};
  }
`;

export default function MoreOptions(props: any) {
  const styleVars = getComputedStyle(document.querySelector(':root') as any);
  const foreground = styleVars.getPropertyValue('--headerColor');

  return (
    <div className="more-options">
      {props.data.isMultiLingualEnabled === 'true' ? (
        <EachOption
          {...{ foreground: foreground }}
          className="each-option"
          style={{
            color: foreground
          }}
          onClick={() => {
            props.toggleLang();
            props.closepane();
          }}
        >
          <span>
            <Icons.Language fill={foreground + 'bf'} />
          </span>
          <div className="body-text-1">
            <T labelName="languageChange" />
          </div>
        </EachOption>
      ) : null}
      {props.isUserLoggedin ? (
        <EachOption
          {...{ foreground: foreground }}
          style={{
            color: foreground
          }}
          className="each-option"
          onClick={() => {
            props.triggerLogout();
            props.closepane();
          }}
        >
          <span>
            <Icons.Logout fill={foreground + 'bf'} />
          </span>
          <div className="body-text-1">
            <T labelName="logoutLabel" />
          </div>
        </EachOption>
      ) : null}

      {!props.isOverlayVisible && props.data.notification === 'true' ? (
        <EachOption
          {...{ foreground: foreground }}
          className="each-option"
          style={{
            color: foreground
          }}
          onClick={() => {
            props.toggleOverlay();
            props.closepane();
          }}
        >
          <span>
            {props.toShowRedDot ? (
              <Icons.NotificationFull fill={foreground + 'bf'} />
            ) : (
              <Icons.Notification fill={foreground + 'bf'} />
            )}
          </span>
          <div className="body-text-1">
            <T labelName="notificationsLabel" />
          </div>
        </EachOption>
      ) : props.isOverlayVisible &&
        !props.headerExternalTheme &&
        !props.data.isInsideCampaign ? (
        <>
          <EachOption
            {...{ foreground: foreground }}
            style={{
              color: foreground
            }}
            className="each-option"
            onClick={() => {
              props.hideBot();
            }}
          >
            <span>
              <Icons.Minimise fill={foreground + 'bf'} />
            </span>
            <div className="body-text-1">
              {props.isChatBodyVisible ? (
                <T labelName="minimiseLabel" />
              ) : (
                <T labelName="maximiseLabel" />
              )}
            </div>
          </EachOption>
          {!props.data.isInsideAware ? (
            <EachOption
              {...{ foreground: foreground }}
              style={{
                color: foreground
              }}
              className="each-option"
              onClick={() => {
                if (props.handleModalToggle) {
                  if (props.feedbackDone || props.data.isInsideAware)
                    props.handleModalToggle(true, false, true);
                  // else props.handleModalToggle(false, true, true); //this is to open feedback on close
                  else props.handleModalToggle(false, false, false); //this is to removed when open feedback on close
                } else props.hideBot();
              }}
            >
              <span>
                <Icons.Close fill={foreground + 'bf'} />
              </span>
              <div className="body-text-1">
                {' '}
                <T labelName="closeLabel" />
              </div>
            </EachOption>
          ) : null}
        </>
      ) : null}
    </div>
  );
}
